import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import axios from '~/data/http/axios'
import DataTable1 from '~/Common-Objects/Tables/DataTable1/DataTable1'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Paper from '~/Common-Objects/UI/Paper/Paper'
import SquareChip from '~/Common-Objects/UI/Chips/SquareChip.jsx'
import { alterSiteDrawer } from '~/data/actions/siteActions'
import DateTimeFunctions from '~/Classes/dateTimeFunctions'
import i18n from '~/i18n'

export default function ContactLinkTags({ SubscriberId }) {
    const [linkTags, setLinksTags] = useState(null)
    const dispatch = useDispatch()

    const getTags = async () => {
        setLinksTags((await axios.get('/subscriber/' + SubscriberId + '/tags?tagType=1')).data)
    }

    const viewHistory = (tag) => {
        dispatch(
            alterSiteDrawer(true, true, 'right', <LinkTagHistory SubscriberId={SubscriberId} tag={tag} />, true, 800)
        )
    }

    useEffect(() => {
        getTags()
    }, [SubscriberId])

    if (!linkTags) return <LoadingIcons />

    console.log()

    return (
        <Paper className='mar-t20 mar-b0'>
            <h4 className='mar-b20'>{i18n.t('subscribers:subscriber.linkTags.header')}</h4>
            {!linkTags.length && <div>{i18n.t('subscribers:subscriber.linkTags.noTags')}</div>}
            {linkTags.map((tag) => (
                <SquareChip
                    key={tag.id}
                    className='square-chip square-chip-large mar-r10 mar-b10'
                    onClick={() => viewHistory(tag)}
                    iconRight={<Icons icon='arrowRight' />}
                >
                    {tag.tagName}
                </SquareChip>
            ))}
        </Paper>
    )
}

function LinkTagHistory({ SubscriberId, tag }) {
    const history = useHistory()
    const [results, setResults] = useState(null)

    const getHistory = async () => {
        setResults((await axios.get('/subscriber/' + SubscriberId + '/tags/' + tag.id + '/history')).data.reverse())
    }

    useEffect(() => {
        getHistory()
    }, [SubscriberId, tag.id])

    if (!results) return <LoadingIcons />

    const data = results.map((row) => {
        return {
            date: {
                headerValue: i18n.t('subscribers:subscriber.linkTags.date'),
                value: DateTimeFunctions.formatDateTime(row.createdAt)
            },
            link: {
                headerValue: i18n.t('subscribers:subscriber.linkTags.link'),
                value: row.LinkTag.link
            },
            campaign: {
                headerValue: i18n.t('subscribers:subscriber.linkTags.campaign'),
                value: row.Campaign ? (
                    <a onClick={() => history.push('/cp/campaigns/view/' + row.CampaignId)}>
                        {row.Campaign.campaignName}
                    </a>
                ) : (
                    i18n.t('subscribers:subscriber.linkTags.deleted')
                )
            }
        }
    })

    return (
        <div>
            <h4 className='mar-b25'>{i18n.t('subscribers:subscriber.linkTags.clicks', { tagName: tag.tagName })}</h4>
            <DataTable1 tableData={data} />
        </div>
    )
}
